import { create } from 'zustand';

interface UseSidebarStore {
  data: boolean;
  toggleSidebar: () => void;
}

export const useSidebarStore = create<UseSidebarStore>((set, get) => ({
  data: false,

  toggleSidebar: () => set({ data: !get().data }),
}));
